import * as React from 'react';

import { CdnIcon } from '@websky/core/src/__fsd__/shared/ui';
import BaggageCardComponent from '@websky/core/src/Baggage/BaggageCard';

const BaggageCard: React.FC<React.ComponentProps<typeof BaggageCardComponent>> = props => {
	return <BaggageCardComponent {...props} icon={<CdnIcon icon="Baggage/Sport Equipment" />} />;
};

export default BaggageCard;
